import Vue from 'vue'
import store from '@/store'

Vue.directive('check-business', {
  inserted(el, binding, node) {
    const businessType = binding.value
    if (!store.getters['businessTypes/isEnabled'](businessType)) {
      node.elm.parentElement.removeChild(node.elm)
    }
  },
})
